function nunjucks_filter_transchoice(i18n)
{
    this.isAsync = false;
    this.name = 'transChoice';
    this.filter = function(str, count, repl, lang)
    {
        return i18n.transChoice(str||'', count, repl, lang);
    };
}
